/**
 * The overlapping colour swatch stack on an influencer card (design spec §2.3).
 *
 * Circles overlap by ~30%, capped at eight, then a "+N more" chip. The overlap is done with
 * a negative margin rather than absolute positioning so the row still centres and wraps
 * naturally at narrow widths.
 *
 * Accessibility: the stack is one labelled group rather than N separate items — a screen
 * reader user wants "4 colours in common: Sage, Chalk, ..." and not four unlabelled dots.
 */
export const SwatchStack = ({ swatches = [], overflow = 0, moreLabelTemplate = "+{0} more" }) => {
  if (!swatches.length) {
    return null;
  }

  const moreLabel = moreLabelTemplate.replace("{0}", String(overflow));
  const groupLabel = swatches.map((s) => s.name || s.colourCode).join(", ");

  return (
    <ul
      className="influencer-card__swatches"
      data-testid="influencer-card-swatches"
      aria-label={groupLabel}
    >
      {swatches.map((swatch, index) => (
        <li
          key={`${swatch.colourCode}-${index}`}
          className="influencer-card__swatch"
          style={{ backgroundColor: `rgb(${swatch.rgb})` }}
          title={swatch.name || swatch.colourCode}
          aria-hidden="true"
        />
      ))}

      {overflow > 0 && (
        <li
          className="influencer-card__swatch influencer-card__swatch--more"
          data-testid="influencer-card-swatch-overflow"
        >
          {moreLabel}
        </li>
      )}
    </ul>
  );
};
